import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f8a9fc4a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "欢迎登录！", -1));

const _hoisted_3 = {
  class: "form-wrap"
};
const _hoisted_4 = {
  class: "form"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, [/*#__PURE__*/_createElementVNode("text", null, "机"), /*#__PURE__*/_createElementVNode("text", null, "构"), /*#__PURE__*/_createElementVNode("text", null, "口"), /*#__PURE__*/_createElementVNode("text", null, "令")], -1));

const _hoisted_6 = {
  class: "input"
};
const _hoisted_7 = {
  class: "form"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, [/*#__PURE__*/_createElementVNode("text", null, "工"), /*#__PURE__*/_createElementVNode("text", {
  style: {
    "opacity": "0"
  }
}, "工"), /*#__PURE__*/_createElementVNode("text", {
  style: {
    "opacity": "0"
  }
}, "号"), /*#__PURE__*/_createElementVNode("text", null, "号")], -1));

const _hoisted_9 = {
  class: "input"
};
const _hoisted_10 = {
  class: "form"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, [/*#__PURE__*/_createElementVNode("text", null, "密"), /*#__PURE__*/_createElementVNode("text", {
  style: {
    "opacity": "0"
  }
}, "密"), /*#__PURE__*/_createElementVNode("text", {
  style: {
    "opacity": "0"
  }
}, "码"), /*#__PURE__*/_createElementVNode("text", null, "码")], -1));

const _hoisted_12 = {
  class: "input"
};
const _hoisted_13 = {
  class: "form"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "+86", -1));

const _hoisted_15 = {
  class: "input"
};
const _hoisted_16 = {
  class: "form"
};
const _hoisted_17 = {
  class: "input"
};
const _hoisted_18 = {
  class: "btn-wrap"
};
const _hoisted_19 = {
  class: "agreement"
};
const _hoisted_20 = {
  class: "content"
};
import { reactive, ref } from 'vue';
import { $getLoginCode, $jobNoLogin, $mobileLogin } from '@/service';
import { useStore } from '@/store';
import { Dialog, Toast } from 'vant';
import { useRouter } from 'vue-router';
export default {
  __name: 'Login',

  setup(__props) {
    let checked = ref(false);
    let phoneLogin = ref(false);
    let unBind = ref(false);
    let form = reactive({
      command: '',
      jobNo: '',
      password: '',
      code: '',
      phone: '',
      wxOpenId: ''
    });
    let timer = null;
    let codeTime = ref(0);
    const router = useRouter();
    const store = useStore();
    store.changeTabBar(0);
    form.wxOpenId = store.openId;
    document.title = '登录';

    function toggleLoginWay() {
      phoneLogin.value = !phoneLogin.value;

      if (phoneLogin.value) {
        form.command = '';
        form.jobNo = '';
        form.password = '';
      } else {
        form.phone = '';
        form.code = '';
      }
    }

    pushHistory();

    function pushHistory() {
      let state = {
        title: 'title',
        url: '#'
      }; //修改历史记录状态

      window.history.pushState(state, 'title', '#');
    }

    window.onpopstate = function () {
      location.href = window.location.href;
    };

    async function getLoginCode() {
      if (!validatePhone()) {
        return;
      }

      if (codeTime.value !== 0) {
        return;
      }

      const data = await $getLoginCode(form.phone);

      if (data) {
        codeTime.value = 60;
        timer = setInterval(() => {
          if (codeTime.value === 0) {
            clearInterval(timer);
            return;
          }

          codeTime.value--;
        }, 1000);
      }
    }

    function login() {
      if (!checked.value) {
        Toast('请阅读并勾选用户协议');
        return;
      }

      if (phoneLogin.value ? validateMobileLogin() : validateJobNoLogin()) {
        if (unBind.value) {
          phoneLogin.value ? jobNoLogin() : mobileLogin();
          return;
        }

        phoneLogin.value ? mobileLogin() : jobNoLogin();
      }
    }

    function validatePhone() {
      if (!form.phone || !/^1[0-9]{10}$/g.test(form.phone)) {
        Toast('请输入正确的手机号');
        return false;
      }

      return true;
    }

    function validateMobileLogin() {
      if (!validatePhone()) {
        return false;
      }

      if (!form.code) {
        Toast('请输入验证码');
        return false;
      }

      return true;
    }

    function validateJobNoLogin() {
      if (!form.command) {
        Toast('请输入机构口令');
        return false;
      }

      if (!form.jobNo) {
        Toast('请输入员工工号');
        return false;
      }

      if (!form.password) {
        Toast('请输入密码');
        return false;
      }

      return true;
    }

    async function mobileLogin() {
      const res = await $mobileLogin(form);
      const {
        status,
        message,
        data
      } = res;

      if (status === 101001) {
        Dialog.alert({
          title: '提示',
          message: '此手机号未绑定工号，请先绑定工号',
          confirmButtonColor: '#409EFF'
        }).then(() => {
          phoneLogin.value = false;
          unBind.value = true;
        });
        return;
      }

      if (status !== 200) {
        Toast(message);
      } else {
        const {
          token,
          defaultPassword
        } = data;
        store.updateToken(token);
        store.saveIsDefaultPwd(defaultPassword);
        router.replace('/index');
      }
    }

    async function jobNoLogin() {
      const res = await $jobNoLogin(form);
      const {
        status,
        message,
        data
      } = res;

      if (status === 101001) {
        Dialog.alert({
          title: '提示',
          message: '此工号未绑定手机号，请先绑定手机号',
          confirmButtonColor: '#409EFF'
        }).then(() => {
          phoneLogin.value = true;
          unBind.value = true;
        });
        return;
      }

      if (status !== 200) {
        Toast(message);
      } else {
        const {
          token,
          defaultPassword
        } = data;
        store.updateToken(token);
        store.saveIsDefaultPwd(defaultPassword);
        router.replace('/index');
      }
    }

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [!_unref(phoneLogin) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).command = $event),
        placeholder: "请输入机构口令",
        type: "text"
      }, null, 512), [[_vModelText, _unref(form).command]])])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).jobNo = $event),
        placeholder: "请输入员工工号",
        type: "text"
      }, null, 512), [[_vModelText, _unref(form).jobNo]])])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).password = $event),
        placeholder: "请输入密码",
        type: "password"
      }, null, 512), [[_vModelText, _unref(form).password]])])])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).phone = $event),
        placeholder: "请输入手机号",
        type: "tel"
      }, null, 512), [[_vModelText, _unref(form).phone]])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).code = $event),
        placeholder: "请输入验证码",
        type: "tel"
      }, null, 512), [[_vModelText, _unref(form).code]])]), _createElementVNode("div", {
        class: "label-code",
        onClick: _cache[5] || (_cache[5] = $event => getLoginCode())
      }, _toDisplayString(_unref(codeTime) === 0 ? '获取验证码' : `${_unref(codeTime).toString().padStart(2, '0')}s`), 1)])], 64)), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
        class: "btn btn-login",
        onClick: _cache[6] || (_cache[6] = $event => login())
      }, _toDisplayString(_unref(unBind) ? '绑定并登录' : '登    录'), 1), !_unref(unBind) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "btn btn-phone",
        onClick: _cache[7] || (_cache[7] = $event => toggleLoginWay())
      }, _toDisplayString(!_unref(phoneLogin) ? '手机号' : '工号') + "登录 ", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_withDirectives(_createElementVNode("img", {
        class: "icon",
        src: "/static/icon-checkbox-uncheck.png",
        onClick: _cache[8] || (_cache[8] = $event => _isRef(checked) ? checked.value = false : checked = false)
      }, null, 512), [[_vShow, !_unref(checked)]]), _withDirectives(_createElementVNode("img", {
        class: "icon",
        src: "/static/icon-checkbox-checked.png",
        onClick: _cache[9] || (_cache[9] = $event => _isRef(checked) ? checked.value = true : checked = true)
      }, null, 512), [[_vShow, _unref(checked)]]), _createElementVNode("div", _hoisted_20, [_createElementVNode("text", {
        onClick: _cache[10] || (_cache[10] = $event => _isRef(checked) ? checked.value = !_unref(checked) : checked = !_unref(checked))
      }, "我已阅读并同意"), _createElementVNode("text", {
        class: "link",
        onClick: _cache[11] || (_cache[11] = $event => _ctx.$router.push('/treaty'))
      }, "《用户服务协议》")])])])]);
    };
  }

};